import React from 'react';
import { FaFilePdf } from 'react-icons/fa';
import CargasFuente from '../../components/InversionesExterior/CargasFuente';
import CuadraturaPdf from '../../components/InversionesExterior/pdf/CuadraturaPdf';
import inversionesExteriorPdfService from '../../services/inversionesExteriorPdfService';

/**
 * Tarjeta PDF: cualquier documento sobre inversiones o rentas en el exterior (cartolas,
 * reportes anuales, contratos, acuerdos entre privados, préstamos, escrituras).
 * La IA propone las filas; la revisión y la validación son las comunes de las cargas.
 * Todo lo del PDF en el servidor está en src/services/inversionesExterior/pdf/
 */
const PdfPage = ({ token, id_company }) => (
    <CargasFuente
        token={token}
        idCompany={id_company}
        fuente="pdf"
        titulo="PDF"
        icono={<FaFilePdf />}
        extensiones=".pdf"
        subir={(datos, tokenSesion) => inversionesExteriorPdfService.subirPdf(datos, tokenSesion)}
        mensajeLectura="Leyendo el PDF con IA; puede tardar hasta 2 minutos"
        extraPropuesta={(carga) => <CuadraturaPdf carga={carga} token={token} />}
        ayuda={(
            <>
                Sube un documento sobre inversiones o rentas en el exterior, de hasta 10 MB: una cartola o el reporte
                anual de un banco o broker, un contrato de compraventa, un acuerdo de inversión entre privados, un
                préstamo o una escritura. La IA propone una fila por inversión y tipo de renta con los montos del
                documento, y TAXI los pasa a pesos con la tasa al 31-12. Lo que el documento no trae, como el domicilio
                de un emisor, queda en blanco para que lo completes. Revisa todo antes de validar. El PDF se guarda.
            </>
        )}
    />
);

export default PdfPage;
